import React, { useEffect, useState } from "react";
import { getArrayListener } from "../firebase/fireFuncs";
import { forArrayLength, getBoxTypeNames } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import collectionStore from "./../stores/collectionStore";

const useHandleListeners = () => {
  const [unsubs, setUnsubs] = useState([]);
  const { player } = MainStore();
  const { setArray } = collectionStore();

  function onArrayFound(collection, type, array) {
    setArray(collection, type, array);
  }

  useEffect(() => {
    if (player) {
      forArrayLength(unsubs, (unsub) => {
        unsub();
      });
      const boxTypeNames = getBoxTypeNames(player.boxTypes);

      getArrayListener(player, boxTypeNames, onArrayFound, takeUnsubs);
    }
  }, [player?.boxTypes]);

  function takeUnsubs(unsubs) {
    setUnsubs(unsubs);
  }
  return { onArrayFound };
};

export default useHandleListeners;
